import React, { ChangeEventHandler, forwardRef, useCallback } from 'react';

import { ReservationFlowProductCustomerFieldItem } from 'src/interfaces/reservation_flow';
import { useDataAttributeProps } from 'src/hooks/useDataAttributeProps';
import { RSTextField } from 'src/reservation-page/forms/RSTextField';

export interface CustomerInfoInputTextFieldProps {
  [key: `data-${string}`]: string | undefined;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  item: ReservationFlowProductCustomerFieldItem;
  isError?: boolean;
}

export const CustomerInfoInputTextField = forwardRef<
  HTMLInputElement,
  CustomerInfoInputTextFieldProps
>((props, ref) => {
  const dataAttributes = useDataAttributeProps(props);
  const { value, onChange, onBlur, item, isError } = props;
  const onInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div>
      <div className="mb-1.5">
        <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
          {item.description.length > 0 ? item.description : item.label}
        </div>
      </div>
      <div>
        <RSTextField
          {...dataAttributes}
          ref={ref}
          labelText={item.label}
          isBlock
          isError={isError}
          required={item.is_required}
          value={typeof value !== 'undefined' ? value : ''}
          onChange={onInputChange}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
});

CustomerInfoInputTextField.displayName = 'CustomerInfoInputTextField';
